import loadjs from "loadjs";
import config from "config";

class Clevercast {
  constructor(container) {
    this.container = container;
    this.player = null;

    this.init();
  }

  init = () => {
    loadjs("https://player.clevercast.com/js/api.min.js", {
      numRetries: 3,
      success: this.loadSuccess,
      error: (depsNotFound) => {
        console.log(depsNotFound);
      },
    });
  };

  loadSuccess = async () => {
    if (!this.container.dataset?.clevercastLoaded) {
      this.container.dataset.clevercastLoaded = true;

      const { id } = this.container;

      const { itemId } = this.container.dataset;

      const options = {
        autoplay: false,
        autoload: "off",
        captions_default: "nl",
        captions_default_show: true,
        chromecast: true,
        account_id: config.CLEVERCAST.ACCOUNT_ID,
        item_id: itemId,
      };

      const playerConfig = {
        id,
        responsive: true,
        options,
      };

      this.player = new window.RMP(playerConfig);
    }
  };

  play = () => {
    if (this.player) {
      this.player.play();
    }
  };

  pause = () => {
    if (this.player) {
      this.player.pause();
    }
  };
}

export default Clevercast;
